
import CREATE_COMMENT_ES from './createComment.graphql'
import GET_COMMENT_ES from './getComments.graphql'

export {CREATE_COMMENT_ES, GET_COMMENT_ES }



// WEBPACK FOOTER //
// ./src/modules/common/graphql/comment/index.ts